module.exports = __webpack_public_path__ + "img/linkedin.bf95f38.svg";